export default {
  ad_hoc_corrective: "Ad-Hoc Corrective Work",
  ad_hoc_regular: "Ad-Hoc Regular Work",
  area: "Area",
  areas: "Areas",
  area_id: "Area ID",
  by: "By",
  event_added: "Added",
  event_changed: "Changed",
  event_change_requested: "Change Requested",
  event_removed: "Removed",
  item: "Item",
  items: "Items",
  item_id: "Item ID",
  item_location_id: "Location ID",
  item_model: "Model",
  issue_label_deadline: "Deadline for Correction",
  issue_label_procedure_steps: "Related steps (ID)",
  issue_no_procedure_steps: "None",
  issue_label_step_reference: "Step referencing",
  not_applicable: "N/A",
  issue_label_raised: "Raised",
  layout: "Layout",
  layouts: "Layouts",
  layout_id: "Layout ID",
  location: "Location",
  model_code: "Model code",
  model_manufacturer: "Manufacturer",
  maintenance_scheduled: "Maintenance Scheduled",
  performed: "Performed",
  planned_corrective: "Planned Corrective Work",
  planned_regular: "Planned Regular Work",
  organisation: "Organisation",
  requester: "Requester",
  risk: "Risk factor",
  support: "{support}",
  zone_id: "Zone ID",
  qr: "QR code",
  barcode: "Barcode",
  rfid: "RFID",
  unknown_user: "Unknown",
  system_user: "SYSTEM",
  error_user: "ERROR",
  title_corrective_work: "Corrective Work",
  title_closed_without_correction: "Closed without Correction",
  title_corrected_and_closed: "Corrected and closed",
  title_issue_rejected: "Issue rejected",
  title_issue_superseded: "Superseded",
  title_issue_supersedes_another: "This Issue supersedes another",
  title_corrective_work_rejected: "Corrective Work rejected",
  title_corrective_work_accepted: "Corrective Work accepted",
  title_issue_raised: "Raised",
  title_repeated_observation: "Repeated Observation",
  title_edited_correction_info: "Edited Correction Information",
  title_work_order_added: "Added to Work Order",
  title_work_order_removed: "Removed from Work Order",
  work_accepted: "Work Accepted",
  work_rejected: "Work Rejected",
  processed: "Processed",
  work_order: "Work Order",
  corrected_on: "Corrected on",
  corrected_on_date_by: "Corrected on {date} by",
  closed_on: "Closed on",
  closed_by: "Closed by",
  corrective_work_on: "Corrective Work on",
  reasoning: "Reasoning",
  rejection_reason: "Reason for rejection",
  superseding_issue: "Superseding Issue",
  superseded_issue: "Superseded Issue",
  performed_regular_work: "Performed Regular Work",
  rejected_by: "Rejected by",
  accepted_by: "Accepted by",
  relation: "Relation",
  reference: "Reference",
  deadline: "Deadline",
  work_description: "Work description",
  no_value: "No Value",
}
